import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import $ from 'jquery';
import 'jszip';
import 'pdfmake/build/pdfmake.min';
import 'pdfmake/build/vfs_fonts';
import 'prismjs/themes/prism.css';
import moment from 'moment/min/moment.min.js';

import './index.css';
import './global-components/assets/css/dashmix.css';
import './global-components/assets/css/customStyle.css';

import ErrorBoundary from './global-components/ErrorBoundary';
import PageLoad from './modules/ApplicationPortal/Pages/Features/pageLoad';
import store from './modules/SecuredPanel/utils/store';
import { updateSchool } from './modules/SecuredPanel/utils/schoolDetailsStore';
import App from './App';
import * as serviceWorker from './serviceWorker';

// import React, {useState} from 'react';
// import ReactDOM from 'react-dom';
// import $ from 'jquery';
// import * as jQuery from "jquery";
// import { BrowserRouter } from "react-router-dom";
// import './index.css';
// import axios from 'axios';
// import modules from './modules';
// import App from './App';
// import { Provider, useDispatch, useSelector } from 'react-redux';
// import { createStore } from 'redux';
// import * as serviceWorker from './serviceWorker';
// import { school, updateSchool } from './store/school/school';
// import { updateUser } from './store/user/user';
// import infoCombine from './store';
// import { Suspense } from "react";
// import Loading from './modules/ApplicationPortal/Pages/Features/loader';
// import PageLoad from './modules/ApplicationPortal/Pages/Features/pageLoad';
// import {ThemeProvider} from "styled-components";
// import { GlobalStyles } from "./global-components/globalstyles";
// import { lightTheme, darkTheme } from "./global-components/themes"
// import icon from "./global-components/assets/img/ico.ico"
// import "./global-components/assets/css/dashmix.css";
// import "./global-components/assets/css/customStyle.css";
// import DomainNotTaken from './global-components/DomainNotTaken';
// import SessionTimeout from './global-components/SessionTimeout';
// import ErrorBoundary from './global-components/ErrorBoundary';
// import ButtonComponent from './global-components/ErrorBoundary'; 
// import data from './modules/ApplicationPortal/components/constants';
// import store from './modules/SecuredPanel/utils/store';
// import { updateSchool } from './modules/SecuredPanel/utils/schoolDetailsStore';
// import { object } from 'prop-types';
// import { ShowInactive } from './global-components/InactiveComponent';
// import { createRoot } from 'react-dom/client';






// const fetch = require('sync-fetch')
// let host = window.location.hostname
// if (host == 'localhost') {
//   host = data.headers.xtenant
// }

// let url =( window.location.hostname == 'localhost' || host == 'eum.tespire.co') ? 'https://api-staging.tespire.ng/api/school-info' : 'https://api.tespire.ng/api/school-info';

// let school_info
//  // if (!sessionStorage.getItem('school')) {
//   school_info = fetch(url, { headers: { xtenant: host } }).json();

//   localStorage.setItem('school', JSON?.stringify(school_info))
//  //} else {
//  //  school_info = JSON.parse(sessionStorage.getItem('school'))
//  // }


// //const store = createStore(infoCombine);
// //const favicon = document.getElementById("favicon");

//  store.dispatch(updateSchool(school_info));
//         // sch = JSON.stringify(store.getState());
//   //favicon.href = `${school_info?.logo}`;
        
//   localStorage.setItem("jsp-primary", school_info.status == 'false' ? '#330077' : school_info.primary_color)

// window.jQuery = jQuery;
// window.$ = jQuery; 

// const primary = localStorage.getItem("jsp-primary")

// if (localStorage.getItem("jsp-primary") != null) {
//    document.documentElement.style.setProperty("--jsp-primary", primary);
//    document.documentElement.style.setProperty("--jsp-primary-opaque", primary +"c0");
//    document.documentElement.style.setProperty("--jsp-primary-hover", primary +"c9");
// }

// document.querySelectorAll('iframe').forEach(
//   function(elem){
//     elem.parentNode.removeChild(elem);
// });

// window.JSZip = require("jszip");
// require("pdfmake/build/pdfmake.min");
// require("pdfmake/build/vfs_fonts");
// require("prismjs/themes/prism.css");
// require("pdfmake/build/vfs_fonts");
// require('jszip');
// require('pdfmake');
// // require('jquery');

 
// // require("./global-components/assets/js/dashmix.app.min.js");
// var moment = require("moment/min/moment.min.js");

// window.moment = moment;
// window.JSZip = require("jszip");

// const domain = window.location.hostname;

// const rootSrc = document.getElementById("root");
// const root = createRoot(rootSrc);
// root.render(
//   <BrowserRouter>
//     <React.StrictMode>
//       <Provider store={store}>
//         {/* <ThemeProvider theme={theme === 'light' ? lightTheme : darkTheme}>
//       <GlobalStyles/> */}
//       <ErrorBoundary>
//         {/* <ButtonComponent /> */}
//         <Suspense fallback={<PageLoad/>}>
//           {school_info.status == false ? <DomainNotTaken/> : school_info.status == 'inactive' ? <ShowInactive/> : <App />}
//         </Suspense>
//       </ErrorBoundary>
       
//          {/* </ThemeProvider> */}
//         </Provider>
//     </React.StrictMode>{" "}
//     {/* <SessionTimeout/> */}
//   </BrowserRouter>
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();




// jQuery / moment need to be on window for legacy plugins (dashmix.js etc)
window.$ = window.jQuery = $;
window.moment = moment;

const STAGING_HOST = 'eum.tespire.co';
const API_STAGING = 'https://api-staging.tespire.ng/api/school-info';
const API_PROD = 'https://api.tespire.ng/api/school-info';

function getTenantHost() {
  const host = window.location.hostname;
  return host === 'localhost' ? STAGING_HOST : host;
}

function getApiUrl(host) {
  return (window.location.hostname === 'localhost' || host === STAGING_HOST)
    ? API_STAGING
    : API_PROD;
}

function applyThemeColor(school) {
  const primary = school?.status === false ? '#330077' : school?.primary_color;
  if (!primary) return;
  localStorage.setItem('jsp-primary', primary);
  document.documentElement.style.setProperty('--jsp-primary', primary);
  document.documentElement.style.setProperty('--jsp-primary-opaque', `${primary}c0`);
  document.documentElement.style.setProperty('--jsp-primary-hover', `${primary}c9`);
}

// Single source of truth for school-info: cached in sessionStorage,
// fetched once, and passed down as a prop instead of re-fetched
// separately in App.js.
async function fetchSchoolInfo() {
  // const cached = sessionStorage.getItem('school');
  // if (cached) return JSON.parse(cached);

  const host = getTenantHost();
  const url = getApiUrl(host);
  const res = await fetch(url, { headers: { xtenant: host } });
  if (!res.ok) throw new Error(`school-info request failed: ${res.status}`);

  const data = await res.json();
  sessionStorage.setItem('school', JSON.stringify(data));
  localStorage.setItem('school', JSON.stringify(data));
  return data;
}

async function bootstrap() {
  const rootEl = document.getElementById('root');
  const root = createRoot(rootEl);

  // Show a loading state while tenant info loads, instead of blocking
  // the thread with a synchronous fetch before anything can render.
  root.render(<PageLoad />);

  let schoolInfo;
  try {
    schoolInfo = await fetchSchoolInfo();
  } catch (err) {
    console.error('Failed to load school info:', err);
    // Fail safe: treat like an untaken domain rather than crashing.
    schoolInfo = { status: false };
  }

  applyThemeColor(schoolInfo);
  store.dispatch(updateSchool(schoolInfo));

  document.querySelectorAll('iframe').forEach((el) => el.remove());

  root.render(
    <BrowserRouter>
      <React.StrictMode>
        <Provider store={store}>
          <ErrorBoundary>
            <Suspense fallback={<PageLoad />}>
              <App school={schoolInfo} />
            </Suspense>
          </ErrorBoundary>
        </Provider>
      </React.StrictMode>
    </BrowserRouter>
  );
}

bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

